module.exports = __webpack_public_path__ + "img/edit.c0fecc17.svg";